export default __webpack_public_path__ + "images/ninety-account-image_0123c78634f2ed4ae116fe6c3279497f.svg";